import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["filename"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { convertToSupportedLang } from '@infl-ts/util-date';
import { generateRandomFilename } from '@infl-ts/util-generate-random-filename';
import { replaceSpaces } from '@infl-ts/util-string-replace-spaces';
import { Filestack, PickerDisplayMode } from 'filestack-js';
import { absurd } from 'fp-ts/function';
import { useCallback, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { FILESTACK_API_KEY } from '../../env';
import CaptureContainer from './capture-container';
import { imageTypes, videoTypes } from './file-type-white-list';
import { jsx as _jsx } from "react/jsx-runtime";

var dropPaneReducer = function dropPaneReducer(state, action) {
  switch (action.type) {
    case 'uploadFile':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploadedFile: action.value,
        hasError: false
      });

    case 'showError':
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.value
      });

    default:
      return state;
  }
};

export var SOURCE_ERROR = "Cannot use 'in' operator to search for 'source' in undefined";
export var ABORTED_REQUEST = 'Request aborted';
export var UploadFromCapture = function UploadFromCapture(_ref) {
  var onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      clientOptions = _ref.clientOptions,
      storeParams = _ref.storeParams,
      pickerOptions = _ref.pickerOptions,
      error = _ref.error,
      sourceType = _ref.sourceType,
      containerId = _ref.containerId;

  var _useReducer = useReducer(dropPaneReducer, {
    hasError: error,
    uploadedFile: null
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var onUploadCompleted = useCallback(function (uploadedFile) {
    if (uploadedFile) {
      var _file = _objectSpread(_objectSpread({}, uploadedFile), {}, {
        mediaType: sourceType === 'video' ? 'video' : 'image',
        filename: replaceSpaces(uploadedFile.filename)
      });

      dispatch({
        type: 'uploadFile',
        value: _file
      });
      onSuccess(_file);
    } else {
      dispatch({
        type: 'showError',
        value: true
      });
      onError(t('Failed to upload file'));
    }
  }, [state, t]);
  useEffect(function () {
    dispatch({
      type: 'showError',
      value: error
    });
  }, [error]);
  var picker = Filestack(FILESTACK_API_KEY, clientOptions).picker(_objectSpread(_objectSpread({
    rootId: "#".concat(containerId, "-root"),
    container: "#".concat(containerId),
    maxFiles: 1,
    uploadInBackground: true,
    startUploadingWhenMaxFilesReached: true,
    disableTransformer: true,
    accept: sourceType === 'webcam' ? imageTypes : sourceType === 'video' ? videoTypes : absurd(sourceType),
    fromSources: [sourceType],
    onFileSelected: function onFileSelected(_ref2) {
      var filename = _ref2.filename,
          file = _objectWithoutProperties(_ref2, _excluded);

      return Promise.resolve(_objectSpread(_objectSpread({}, file), {}, {
        filename: generateRandomFilename(filename)
      }));
    },
    onFileUploadFinished: function onFileUploadFinished(file) {
      return onUploadCompleted(file);
    },
    onFileUploadFailed: function onFileUploadFailed(_, error) {
      if (error.message === ABORTED_REQUEST || error.message === SOURCE_ERROR) return;
      dispatch({
        type: 'showError',
        value: true
      });
      onError(error.message);
    },
    storeTo: storeParams,
    displayMode: PickerDisplayMode.inline,
    lang: convertToSupportedLang(i18n.language)
  }, pickerOptions), {}, {
    customText: _objectSpread({
      'Drag and Drop, Copy and Paste Files': ' ',
      'Click to record audio, video or pick file': t('Click to record audio, video or pick file'),
      'Please enable your webcam to record video or audio.': t('Please enable your webcam to record video or audio.')
    }, pickerOptions === null || pickerOptions === void 0 ? void 0 : pickerOptions.customText)
  }));
  useEffect(function () {
    if (state.uploadedFile) {
      void picker.close()["catch"](function (error) {
        dispatch({
          type: 'showError',
          value: true
        });
        onError(typeof error === 'string' ? t(error) : t("There's been a problem closing the file picker"));
      });
    } else {
      void picker.open()["catch"](function (error) {
        dispatch({
          type: 'showError',
          value: true
        });
        onError(typeof error === 'string' ? t(error) : t("There's been a problem opening up the file picker"));
      });
    }

    return function () {
      if (picker) {
        void picker.close()["catch"](function (error) {
          dispatch({
            type: 'showError',
            value: true
          });
          onError(typeof error === 'string' ? t(error) : t("There's been a problem closing the file picker"));
        });
      }
    };
  }, [state.uploadedFile, onError, picker, t]);
  return /*#__PURE__*/_jsx(CaptureContainer, {
    id: containerId,
    error: error,
    t: t,
    "data-element": "CaptureContainer",
    "data-component": "UploadFromCapture",
    "data-source-file": "upload-from-capture.tsx"
  });
};